import * as React from 'react';
import {ModalStates} from '../../globals/Constants';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Themeable from '../../types/Themeable';

export default ({setModalState, themeName}: ShareReviewButtonProps) => (
   <ControlButton buttonType={TscButtonType.secondary}
                  label={Strings.labels.share}
                  glyph={<Glyphs.Share16x16/>}
                  onClick={() => setModalState(ModalStates.shareReview)}
                  themeName={themeName}
                  testId="share-review-button" />
);

export interface ShareReviewButtonProps extends Themeable {
   setModalState(modalState: ModalStates): void;
}
